import React from 'react';
import { Col, Row } from '@/elements';
import { Button, Tooltip } from 'antd';
import { PageContentUnderTitle } from '@/components';

const ButtonGroup = Button.Group;

const LiveViewHeader = React.memo(function HolderDrawer({
	count,
	isLessXS,
	columnCount,
	incColumn,
	decColumn,
}) {
	return (
		<Row gutter={16} type="flex" align="middle">
			<Col xs={12}>
				<PageContentUnderTitle>
					Showing {count} contacts
				</PageContentUnderTitle>
			</Col>
			<Col xs={12}>
				<ButtonGroup className="zoom-wrap">
					<Tooltip
						title="Zoom out"
						placement="topLeft"
						onClick={e => e.stopPropagation()}
					>
						<Button
							icon="minus"
							onClick={incColumn}
							disabled={
								(isLessXS && columnCount >= 3) ||
								columnCount >= 7
							}
						/>
					</Tooltip>
					<Tooltip
						title="Zoom in"
						placement="topRight"
						onClick={e => e.stopPropagation()}
					>
						<Button
							tabIndex={-1}
							icon="plus"
							onClick={decColumn}
							disabled={columnCount === 1}
						/>
					</Tooltip>
				</ButtonGroup>
			</Col>
		</Row>
	);
});

export default LiveViewHeader;



// WEBPACK FOOTER //
// ./src/pages/live-view/components/header/index.js